import { ISiteBranch } from "@base/modules/site/site.interface";
import { IDoctor } from "./interface/doctor.interface";

/** The page size the app uses for a doctor's ratings; the profile shows the first page only. */
export const DOCTOR_RATING_PAGE_SIZE = 15;

/** Blank, null and whitespace-only text all mean "no section" - admins leave all three behind. */
export const hasText = (value?: string | null): value is string => !!value && value.trim() !== "";

/** Whole stars for a 0..5 average. Rounds to nearest (4.2 → 4, 4.5 → 5), unlike the app's round-up. */
export const getStarCount = (point?: number | null): number => {
  const value = typeof point === "number" && Number.isFinite(point) ? point : 0;

  return Math.min(5, Math.max(0, Math.round(value)));
};

/**
 * A booking price, or `null` when it is free/unset so the caller shows "Book" instead. Always grouped the
 * Vietnamese way whatever the UI language, since the amount is in đồng.
 */
export const formatDoctorPrice = (amount?: number | null): string | null => {
  if (!amount) {
    return null;
  }

  return `${new Intl.NumberFormat("vi-VN").format(amount)}đ`;
};

/** Only branches the site still runs can be booked. */
export const getActiveBranches = (doctor?: IDoctor): ISiteBranch[] => (doctor?.site_branches ?? []).filter((branch) => branch.active === true);

/** Case- and accent-insensitive form for searching Vietnamese names ("ha noi" finds "Hà Nội"). */
export const foldVietnamese = (value: string): string =>
  value
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .toLowerCase();

export const filterBranches = (branches: ISiteBranch[], keyword: string): ISiteBranch[] => {
  const needle = foldVietnamese(keyword.trim());

  if (!needle) {
    return branches;
  }

  return branches.filter((branch) => !!branch.name && foldVietnamese(branch.name).includes(needle));
};
